import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popovers from "react-bootstrap/Popover";


class ShipDetailsCrewCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      modalIsOpen: false,
      Name: "",
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  renderPopover(props) {
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
          User deleted awaiting to sync with device.
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }

  render() {
    const { totalRecords, pageSize, GetVisitorPhoto } = this.props;
    return (
      <>
      {this.renderCardPendingData()}
        {totalRecords !== 0 ? (
          <Paginator
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !-- No Items to Display --!
              </h6>
            </div>
          </div>
        )}
      </>
    );
  }

  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }
 
 
  renderCardPendingData = () => {
    const { arraylist, showSidePane } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
          return (
            <div className="card click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative"}}>
                           <div className="p-3">
                             <div className="resource-list-auth-date">
                               <div className="row">
                                 <div className="col-sm-11 col-md-11 col-lg-11">
                                   <div className="row">
                                 <div className="col-sm-4 col-md-4 py-2">
                                   <span><strong>Crew ID  : </strong>
                                      <span className="italicFont">  {item.crewId} </span>
                                   </span>
                                 </div>
                                 <div className="col-sm-4 col-md-4 py-2">
                                   <span><strong> Name: </strong>
                                      <span className="italicFont"> {item.name}</span>
                                   </span>
                                 </div>
                                 <div className="col-sm-4 col-md-4 py-2">
                                   <span><strong>Rank : </strong>
                                      <span className="italicFont">  {item.designation} </span>
                                   </span>
                                 </div>
                                 </div>
                                 </div>
                                 <div className="col-sm-1 col-md-1 col-lg-1 col-m-auto text-right">
                                <div
                                  className="m10"
                                  style={{
                                    marginLeft: "10px",
                                    MarginTop: "1rem",
                                  }}
                                >
                                  { item.isDeletedInPortal? (
                                    <OverlayTrigger
                                      placement="bottom"
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={this.renderPopover()}
                                    >
                                      <i
                                        className="fa fa-exclamation-triangle click px-2"
                                        aria-hidden="true"
                                        style={{
                                          color: "#d41616f5",
                                          fontSize: "1.6rem",
                                        }}
                                      ></i>
                                    </OverlayTrigger>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                                </div>
                                
                              </div>
                              
                            </div>
                          </div>
          );
        })
      : null;
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    GetVisitorPhoto: state.VisitorManagementReducer.GetVisitorPhoto || "",
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipDetailsCrewCard)
);